import { sk as sk$1 } from 'date-fns/locale';
import merge from 'lodash/merge';
import error from './error.js';
import login from './login.js';

var sk = {
  language: 'sk',
  country: 'sk',
  name: 'Slovenčina',
  embeddedLocale: merge(error, login),
  flags: ['SK'],
  dateFns: sk$1,
  format: {
    date: 'd.MM.yyyy',
    dateTime: '$t(format:date) $t(format:time)',
    time: 'HH:mm',
  },
};

export { sk as default };
